<div class="grid h-screen overflow-x-hidden">
    <div class="header col-span-2">
        <app-topbar />
    </div>
    <div
        class="content"
        [class.triple-columns]="isDetailPanelOpened()">
        <div class="flex flex-col justify-between gap-2">
            <div>
                <button
                    class="back-btn"
                    type="button"
                    (click)="backToHome()">
                    <fa-icon
                        class="back-btn__icon"
                        size="2xl"
                        [icon]="['far', 'arrow-left']" />
                    <span class="back-btn__label">{{ 'backToProject' | transloco }}</span>
                </button>
            </div>

            <div class="tabs-panel-content">
                <div class="inline-flex items-center gap-3 select-none">
                    <fa-icon
                        class="ml-2 text-secondary"
                        size="2xl"
                        [icon]="['far', 'clipboard']" />
                    <span class="manage-label"> {{ 'management' | transloco }} </span>
                </div>

                <app-management-panel />
            </div>

            <div>
                <button
                    class="back-btn"
                    type="button"
                    (click)="faqService.redirect()">
                    <fa-icon
                        class="back-btn__icon"
                        size="2xl"
                        [icon]="['fas', 'question']" />
                    <span class="back-btn__label">FAQ</span>
                </button>
            </div>
        </div>
        <div class="main-panel overflow-y-auto overflow-x-hidden">
            @if (!securityService.meSignal()) {
                <app-loading />
            } @else {
                <router-outlet />
            }
        </div>
        <div class="flex flex-col details-panel mr-2">
            @if (securityService.meSignal()) {
                <router-outlet name="detailPanel" />
            }
        </div>
    </div>
    <div class="footer col-span-2 text-center">
        <app-version class="ml-8 text-on-surface text-caption" />
    </div>
</div>
